import { Navigate, Outlet } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { Box } from '@mui/material';

import { ReduxRootStateType } from '../redux/store';

function PublicRoute() {
  const user = useSelector((state: ReduxRootStateType) => state.user);

  return user.is_logged_in ? (
    <Navigate to="/" />
  ) : (
    <Box sx={{ width: '100%', height: '100%', position: 'relative' }}>
      <Outlet />
    </Box>
  );
}

export default PublicRoute;
